import { useState } from "react";
import { Check, Clock, UserPlus } from "lucide-react";

import { followUser, unfollowUser } from "../../Services/SocialService";
import type { FollowState } from "../../data/types";

type Props = {
  userId: string;
  followState: FollowState;
  onChange: (next: FollowState) => void;
};

const LABELS: Record<FollowState, string> = {
  none: "Follow",
  requested: "Requested",
  following: "Following",
  self: "You",
};

export default function FollowButton({ userId, followState, onChange }: Props) {
  const [isBusy, setIsBusy] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  if (followState === "self") return null;

  // Redan följd eller väntande — knappen blir en "ångra"-knapp vid hover.
  const isActive = followState === "following" || followState === "requested";

  const label = isActive && isHovering
    ? followState === "following"
      ? "Unfollow"
      : "Cancel"
    : LABELS[followState];

  const handleClick = async () => {
    setIsBusy(true);

    try {
      const res = isActive
        ? await unfollowUser(userId)
        : await followUser(userId);

      onChange(res.followState);
    } catch (e) {
      console.error("follow toggle failed", e);
    } finally {
      setIsBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={`follow-button follow-button--${followState} ${
        isActive && isHovering ? "is-undo" : ""
      }`}
      disabled={isBusy}
      onClick={handleClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {followState === "following" ? (
        <Check size={16} strokeWidth={2.2} />
      ) : followState === "requested" ? (
        <Clock size={16} strokeWidth={2.2} />
      ) : (
        <UserPlus size={16} strokeWidth={2.2} />
      )}

      {label}
    </button>
  );
}
